import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, ProgressBar } from 'react-bootstrap';
import { userManager } from '../utils/oidc';
import moment from 'moment';
import { BaseGatewayImage, GIAYPHEPHANHNGHE_API, CHUNGCHI_CHUYENMON_API, DANHSACH_DUYET_HOSO_API, CME_USER_API, VANBANG_API, CHUNGCHINGOAINGU_API } from '../utils/apiUrl';
import { Get } from '../utils/httpProvider';
import { getByIdAccountAction, getAccountAuthInfoByIdAccountAction, getAccountInfoByIdAccountAction } from '../store/reducers/account';

const Dashboard = () => {
    const dispatch = useDispatch();

    const itemAccount = useSelector((state) => state.account.itemAccount);
    const itemAccountAuthInfo = useSelector((state) => state.account.itemAccountAuthInfo);
    const itemAccountInfo = useSelector((state) => state.account.itemAccountInfo);

    const [userName, setUserName] = useState('');
    const [listGPHN, setListGPHN] = useState([]);
    const [listCCCM, setListCCCM] = useState([]);
    const [duyetHoSoStatus, setDuyetHoSoStatus] = useState(null);
    const [cmeSummary, setCmeSummary] = useState([]);
    const [listVanBang, setListVanBang] = useState([]);
    const [listChungChiNN, setListChungChiNN] = useState([]);

    useEffect(() => {
        const fetchAccountData = async () => {
            const user = await userManager.getUser();
            const accountId = user?.profile?.sub || null;
            setUserName(user?.profile?.preferred_username || 'Chưa cập nhật mã');

            if (accountId) {
                const userId = accountId;
                dispatch(getByIdAccountAction(userId));
                dispatch(getAccountAuthInfoByIdAccountAction(userId));
                dispatch(getAccountInfoByIdAccountAction(userId));

                try {
                    const gphnRes = await Get(GIAYPHEPHANHNGHE_API.GET_ACCOUNT_INFO_ID, userId);
                    let validGphnList = [];
                    if (gphnRes && Array.isArray(gphnRes)) {
                        // Bỏ qua trạng thái Nhập liệu
                        validGphnList = gphnRes.filter(x => x.trangThai !== 'Nhập liệu');
                        setListGPHN(validGphnList);
                    }

                    if (validGphnList.length > 0) {
                        const cccmRes = await Get(CHUNGCHI_CHUYENMON_API.GET_BY_ACCOUNT_INFO_ID, userId);
                        if (cccmRes && Array.isArray(cccmRes)) {
                            // Bỏ qua trạng thái Nhập liệu
                            setListCCCM(cccmRes.filter(x => x.trangThai !== 'Nhập liệu'));
                        }

                        // Lấy trạng thái duyệt hồ sơ của GPHN đầu tiên
                        const firstGphn = validGphnList[0];
                        const dshsRes = await Get(DANHSACH_DUYET_HOSO_API.GET_BY_GIAYPHEP_ID, firstGphn.id);
                        if (dshsRes) {
                            setDuyetHoSoStatus(dshsRes);
                        }
                    }

                    // Fetch VanBang ngoại ngữ
                    const vbRes = await Get(VANBANG_API.GET_BY_ACCOUNT_ID, userId);
                    const vbData = vbRes?.data || vbRes;
                    const vbItems = vbData?.$values || vbData?.data || (Array.isArray(vbData) ? vbData : []);
                    if (Array.isArray(vbItems)) {
                        setListVanBang(vbItems.filter(x => {
                            const s = x.trangThai ?? x.TrangThai;
                            if (s === null || s === undefined) return true;
                            if (!isNaN(s)) return Number(s) !== 0;
                            return String(s) !== 'NhapLieu';
                        }));
                    }

                    // Fetch ChungChi ngoại ngữ
                    const ccRes = await Get(CHUNGCHINGOAINGU_API.GET_BY_ACCOUNT_ID, userId);
                    const ccData = ccRes?.data || ccRes;
                    const ccItems = ccData?.$values || ccData?.data || (Array.isArray(ccData) ? ccData : []);
                    if (Array.isArray(ccItems)) {
                        setListChungChiNN(ccItems.filter(x => {
                            const s = x.trangThai ?? x.TrangThai;
                            if (s === null || s === undefined) return true;
                            if (!isNaN(s)) return Number(s) !== 0;
                            return String(s) !== 'NhapLieu';
                        }));
                    }

                    // Fetch CME summary
                    const cmeRes = await Get(CME_USER_API.GET_MY_SUMMARY);
                    if (cmeRes) {
                        setCmeSummary(cmeRes?.$values || cmeRes?.data || cmeRes || []);
                    }
                } catch (err) {
                    console.error("Lỗi khi fetch dữ liệu Dashboard:", err);
                }
            }
        };
        fetchAccountData();
    }, [dispatch]);

    // Format helpers
    const fullName = [
        itemAccountAuthInfo?.lastName,
        itemAccountAuthInfo?.middleName,
        itemAccountAuthInfo?.firstName
    ].filter(Boolean).join(' ');

    const donViName = itemAccountInfo?.donVis?.map(d => d.tenDonVi).join(', ') || 'Chưa cập nhật đơn vị';
    const email = itemAccountAuthInfo?.email || 'Email chưa cập nhật';
    const phoneNumber = itemAccountAuthInfo?.phoneNumber || 'Chưa cập nhật số điện thoại';
    

    const doiTuongName = itemAccountInfo?.doiTuong?.tenDoiTuong || 'Chưa cập nhật đối tượng';
    const chucDanhChuyenMonName = itemAccountInfo?.chucDanhChuyenMon?.tenDoiTuong || 'Chưa cập nhật';
    const chuyenMonName = itemAccountInfo?.chuyenMons?.map(c => c.tenChuyenMon).join(', ') || 'Chưa cập nhật chuyên môn';

    const formatDate = (date) => date ? moment(date).format('DD/MM/YYYY') : '';
    const getLoaiGiayPhep = (loai) => {
        if (!loai) return 'Chưa cập nhật';
        const strLoai = String(loai).trim().toUpperCase();
        if (strLoai === 'GPHN' || strLoai === '1') return 'Giấy phép hành nghề';
        if (strLoai === 'CCHN' || strLoai === '2') return 'Chứng chỉ hành nghề';
        return loai;
    };
    const getNoiCap = (value) => {
        if (!value) return 'Chưa cập nhật';
        const strValue = String(value).trim().toLowerCase();
        switch (strValue) {
            case 'boyte': return 'Bộ Y tế';
            case 'boquocphong': return 'Bộ Quốc phòng';
            case 'bocongan': return 'Bộ Công an';
            case 'soyte': return 'Sở Y tế';
            case 'khac': return 'Khác';
            default: return value;
        }
    };

    // Resolve Image URL path safely (nếu đã có http thì không nối URL)
    const resolveFileUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
        return `${BaseGatewayImage}/${normalizedPath}`;
    };

    // Calculate CME metrics
    const currentYear = new Date().getFullYear();
    const cmeYearItems = cmeSummary.filter(x => (x.nam || x.Nam) === currentYear);
    const totalHoursYear = cmeYearItems.reduce((sum, item) => sum + (item.tongSoGio || item.TongSoGio || 0), 0);
    const totalPendingHoursYear = cmeYearItems.reduce((sum, item) => sum + (item.tongSoGioChoDuyet || item.TongSoGioChoDuyet || 0), 0);

    const cmeCycleItems = cmeSummary.filter(x => (x.nam || x.Nam) > currentYear - 5 && (x.nam || x.Nam) <= currentYear);
    const totalHoursCycle = cmeCycleItems.reduce((sum, item) => sum + (item.tongSoGio || item.TongSoGio || 0), 0);

    const requiredHoursYear = 24;
    const requiredHoursCycle = 120;
    const progressPercentYear = Math.min(100, (totalHoursYear / requiredHoursYear) * 100);
    const progressPercentCycle = Math.min(100, (totalHoursCycle / requiredHoursCycle) * 100);

    const imageThumbnail = itemAccountAuthInfo?.imageThumbnail;
    const avatarUrl = imageThumbnail ? resolveFileUrl(imageThumbnail) : "/img/default-profile.png";

    // Tính cảnh báo hết hạn giấy phép hành nghề
    const getGPHNExpirationWarning = () => {
        if (listGPHN.length === 0) return null;
        const today = moment().startOf('day');
        let nearestWarning = null;
        for (const gphn of listGPHN) {
            if (!gphn.ngayHetHan) continue;
            const expDate = moment(gphn.ngayHetHan).startOf('day');
            const daysLeft = expDate.diff(today, 'days');
            if (daysLeft < 0) continue; // Đã hết hạn, bỏ qua
            const monthsLeft = expDate.diff(today, 'months', true);
            if (monthsLeft > 6) continue; // Còn hơn 6 tháng, không cảnh báo
            const type = monthsLeft <= 3 ? 'danger' : 'warning';
            if (!nearestWarning || daysLeft < nearestWarning.daysLeft) {
                nearestWarning = { type, daysLeft, soGiayPhep: gphn.soGiayPhep, ngayHetHan: gphn.ngayHetHan };
            }
        }
        return nearestWarning;
    };
    const gphnWarning = getGPHNExpirationWarning();

    const getCCNNWarning = (cc) => {
        const rawDate = cc.ngayHetHan || cc.NgayHetHan;
        if (!rawDate) return null;
        const today = moment().startOf('day');
        const expDate = moment(rawDate).startOf('day');
        const daysLeft = expDate.diff(today, 'days');
        if (daysLeft < 0) return null;
        const monthsLeft = expDate.diff(today, 'months', true);
        if (monthsLeft > 6) return null;
        return { type: monthsLeft <= 3 ? 'danger' : 'warning', daysLeft };
    };

    const renderXacNhanDat = (item) => {
        const xacNhan = item.xacNhanDatYeuCau ?? item.XacNhanDatYeuCau ?? null;
        const lyDo = item.lyDoKhongDat || item.LyDoKhongDat || null;
        if (xacNhan === 'Đạt') {
            return <span className="badge badge-success px-2 py-1" style={{ fontSize: '0.8rem' }}>Đạt</span>;
        }
        if (xacNhan === 'Không đạt') {
            return (
                <div>
                    <span className="badge badge-danger px-2 py-1" style={{ fontSize: '0.8rem' }}>Không đạt</span>
                    {lyDo && (
                        <div className="text-danger mt-1" style={{ fontSize: '0.78rem' }}>
                            <i className="fas fa-info-circle mr-1"></i>{lyDo}
                        </div>
                    )}
                </div>
            );
        }
        return <span className="badge badge-secondary px-2 py-1" style={{ fontSize: '0.8rem' }}>Chưa xác nhận</span>;
    };

    return (
        <div className="container-fluid">
            {gphnWarning && (
                <div
                    className={`alert alert-${gphnWarning.type} d-flex align-items-center shadow-lg mb-4`}
                    style={{
                        borderRadius: '12px',
                        border: `2px solid ${gphnWarning.type === 'danger' ? '#dc3545' : '#f0ad4e'}`,
                        background: gphnWarning.type === 'danger'
                            ? 'linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)'
                            : 'linear-gradient(135deg, #fffdf0 0%, #fff3cd 100%)',
                        padding: '18px 24px',
                    }}
                >
                    <div
                        className="mr-4 d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                            width: '56px', height: '56px', borderRadius: '50%',
                            background: gphnWarning.type === 'danger' ? '#dc3545' : '#ffc107',
                            boxShadow: `0 0 0 6px ${gphnWarning.type === 'danger' ? 'rgba(220,53,69,0.15)' : 'rgba(255,193,7,0.2)'}`,
                        }}
                    >
                        <i
                            className={`fas ${gphnWarning.type === 'danger' ? 'fa-exclamation-circle' : 'fa-exclamation-triangle'}`}
                            style={{ fontSize: '1.6rem', color: '#fff' }}
                        ></i>
                    </div>
                    <div className="flex-grow-1">
                        <h5 className="mb-1 font-weight-bold" style={{ color: gphnWarning.type === 'danger' ? '#c0392b' : '#856404', fontSize: '1.05rem' }}>
                            {gphnWarning.type === 'danger' ? 'CẢNH BÁO: Giấy phép hành nghề sắp hết hạn!' : 'Lưu ý: Giấy phép hành nghề sắp hết hạn'}
                        </h5>
                        <p className="mb-0" style={{ color: gphnWarning.type === 'danger' ? '#7b1e1e' : '#664d03', fontSize: '0.95rem' }}>
                            Giấy phép hành nghề số <strong>{gphnWarning.soGiayPhep}</strong> của bạn còn{' '}
                            <strong style={{ fontSize: '1.1rem' }}>{gphnWarning.daysLeft} ngày</strong> nữa hết hạn (ngày{' '}
                            <strong>{formatDate(gphnWarning.ngayHetHan)}</strong>). Vui lòng gia hạn kịp thời.
                        </p>
                    </div>
                    <div className="ml-3 flex-shrink-0 text-center" style={{ minWidth: '70px' }}>
                        <div style={{
                            fontSize: '2rem', fontWeight: 'bold',
                            color: gphnWarning.type === 'danger' ? '#dc3545' : '#e6a817',
                            lineHeight: 1
                        }}>
                            {gphnWarning.daysLeft}
                        </div>
                        <div style={{ fontSize: '0.75rem', color: gphnWarning.type === 'danger' ? '#c0392b' : '#856404', fontWeight: '600' }}>ngày còn lại</div>
                    </div>
                </div>
            )}
            <div className="row mb-4">
                {/* Left Column: Thông tin tổng quan (User Info) */}
                <div className="col-md-4 col-lg-3">
                        <Card className="card-primary card-outline" style={{ borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                            <Card.Body className="box-profile">
                                <div className="text-center mb-3 mt-3">
                                    <img
                                        className="profile-user-img img-fluid img-circle"
                                        src={avatarUrl}
                                        alt="User profile"
                                        style={{ width: '150px', height: '150px', objectFit: 'cover', border: '3px solid #e9ecef' }}
                                    />
                                </div>
                                <h3 className="profile-username text-center font-weight-bold" style={{ fontSize: '1.2rem', color: '#1a202c', marginBottom: '4px' }}>
                                    {fullName || 'Chưa cập nhật họ tên'}
                                </h3>
                                <p className="text-center text-primary mb-1" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                                    {donViName}
                                </p>
                                <p className="text-muted text-center mb-4" style={{ fontSize: '0.85rem' }}>
                                    <i className="fas fa-envelope mr-1"></i> {email}
                                </p>

                                <hr style={{ borderTop: '2px solid #28a745', width: '80%', margin: '0 auto 20px auto' }} />

                                <div className="d-flex align-items-center mb-4">
                                    <div className="icon-container mr-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: '#fdf3f5', borderRadius: '8px', color: '#dc3545' }}>
                                        <i className="fas fa-phone-alt"></i>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="text-muted text-uppercase" style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>Số điện thoại</span>
                                        <span className="font-weight-bold" style={{ fontSize: '0.9rem', color: '#2d3748' }}>{phoneNumber}</span>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center mb-4">
                                    <div className="icon-container mr-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: '#fcf8e3', borderRadius: '8px', color: '#ffc107' }}>
                                        <i className="fas fa-key"></i>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="text-muted text-uppercase" style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>Mã nhân viên</span>
                                        <span className="font-weight-bold" style={{ fontSize: '0.9rem', color: '#2d3748' }}>{userName}</span>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center mb-4">
                                    <div className="icon-container mr-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: '#e8f5e9', borderRadius: '8px', color: '#2e7d32' }}>
                                        <i className="fas fa-user-md"></i>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="text-muted text-uppercase" style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>Chức danh chuyên môn</span>
                                        <span className="font-weight-bold" style={{ fontSize: '0.9rem', color: '#2d3748' }}>{chucDanhChuyenMonName}</span>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center mb-4">
                                    <div className="icon-container mr-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: '#f8f9fa', borderRadius: '8px', color: '#6c757d' }}>
                                        <i className="fas fa-briefcase"></i>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="text-muted text-uppercase" style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>Chức danh đang hoạt động</span>
                                        <span className="font-weight-bold" style={{ fontSize: '0.9rem', color: '#2d3748' }}>{doiTuongName}</span>
                                    </div>
                                </div>

                                {/* <div className="d-flex align-items-center mb-3">
                                    <div className="icon-container mr-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', backgroundColor: '#e9ecef', borderRadius: '8px', color: '#343a40' }}>
                                        <i className="fas fa-graduation-cap"></i>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <span className="text-muted text-uppercase" style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>Chuyên môn</span>
                                        <span className="font-weight-bold" style={{ fontSize: '0.9rem', color: '#2d3748' }}>{chuyenMonName}</span>
                                    </div>
                                </div> */}

                            </Card.Body>
                        </Card>

                        {/* Block: Văn bằng ngoại ngữ */}
                        <Card className="shadow-sm mt-3" style={{ borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                            <Card.Header className="bg-white border-0 pt-3 pb-2">
                                <h3 className="card-title font-weight-bold" style={{ fontSize: '1.05rem', color: '#1a202c' }}>
                                    <i className="fas fa-graduation-cap mr-2" style={{ color: '#6f42c1' }}></i> Văn bằng ngoại ngữ
                                </h3>
                            </Card.Header>
                            <Card.Body className="pt-0 pb-3">
                                {listVanBang.length === 0 ? (
                                    <div className="text-center text-muted py-2">
                                        <i className="fas fa-folder-open d-block mb-1" style={{ fontSize: '1.3rem' }}></i>
                                        <p style={{ fontSize: '0.82rem', marginBottom: 0 }}>Chưa có dữ liệu</p>
                                    </div>
                                ) : (
                                    listVanBang.map((vb, idx) => (
                                        <div key={idx} className={idx < listVanBang.length - 1 ? 'mb-3 pb-3 border-bottom' : 'mb-1'} style={{ fontSize: '0.82rem' }}>
                                            <div className="mb-1"><span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Tên văn bằng:</span><strong className="text-dark">{vb.tenVanBang || vb.TenVanBang || '---'}</strong></div>
                                            <div className="mb-1"><span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Chuyên ngành:</span><span className="text-dark">{vb.chuyenNganh || vb.ChuyenNganh || '---'}</span></div>
                                            <div className="mb-2"><span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Quốc gia cấp:</span><span className="text-dark">{vb.quocGiaCap || vb.QuocGiaCap || '---'}</span></div>
                                            <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                                                <span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Trạng thái:</span>{renderXacNhanDat(vb)}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </Card.Body>
                        </Card>

                        {/* Block: Chứng chỉ ngoại ngữ */}
                        <Card className="shadow-sm mt-3" style={{ borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                            <Card.Header className="bg-white border-0 pt-3 pb-2">
                                <h3 className="card-title font-weight-bold" style={{ fontSize: '1.05rem', color: '#1a202c' }}>
                                    <i className="fas fa-language mr-2" style={{ color: '#17a2b8' }}></i> Chứng chỉ ngoại ngữ
                                </h3>
                            </Card.Header>
                            <Card.Body className="pt-0 pb-3">
                                {listChungChiNN.length === 0 ? (
                                    <div className="text-center text-muted py-2">
                                        <i className="fas fa-folder-open d-block mb-1" style={{ fontSize: '1.3rem' }}></i>
                                        <p style={{ fontSize: '0.82rem', marginBottom: 0 }}>Chưa có dữ liệu</p>
                                    </div>
                                ) : (
                                    listChungChiNN.map((cc, idx) => {
                                        const warning = getCCNNWarning(cc);
                                        return (
                                            <div key={idx} className={idx < listChungChiNN.length - 1 ? 'mb-3 pb-3 border-bottom' : 'mb-1'} style={{ fontSize: '0.82rem' }}>
                                                {warning && (
                                                    <div
                                                        className="d-flex align-items-center px-2 py-1 mb-1 rounded"
                                                        style={{
                                                            background: warning.type === 'danger' ? '#fff5f5' : '#fffdf0',
                                                            border: `1px solid ${warning.type === 'danger' ? '#f5c6cb' : '#ffeeba'}`,
                                                            fontSize: '0.78rem',
                                                        }}
                                                    >
                                                        <i
                                                            className={`fas ${warning.type === 'danger' ? 'fa-exclamation-circle' : 'fa-exclamation-triangle'} mr-1`}
                                                            style={{ color: warning.type === 'danger' ? '#dc3545' : '#856404' }}
                                                        ></i>
                                                        <span style={{ color: warning.type === 'danger' ? '#c0392b' : '#856404' }}>
                                                            Hết hạn sau <strong>{warning.daysLeft} ngày</strong>
                                                            {' '}({formatDate(cc.ngayHetHan || cc.NgayHetHan)})
                                                        </span>
                                                    </div>
                                                )}
                                                <div className="mb-1"><span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Tên chứng chỉ:</span><strong className="text-dark">{cc.tenChungChi || cc.TenChungChi || '---'}</strong></div>
                                                <div className="mb-1"><span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Trình độ:</span><span className="text-dark">{cc.trinhDo || cc.TrinhDo || '---'}</span></div>
                                                <div className="mb-2"><span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Quốc gia cấp:</span><span className="text-dark">{cc.quocGiaCap || cc.QuocGiaCap || '---'}</span></div>
                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                                                    <span className="text-muted mr-1" style={{ textTransform: 'uppercase', fontSize: '0.72rem', fontWeight: '600' }}>Trạng thái:</span>{renderXacNhanDat(cc)}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </Card.Body>
                        </Card>

                        {/* Block: Tổng quan CME */}
                        <Card className="shadow-sm mt-3" style={{ borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                            <Card.Header className="bg-white border-0 pt-3 pb-2">
                                <h3 className="card-title font-weight-bold" style={{ fontSize: '1.05rem', color: '#1a202c' }}>
                                    <i className="fas fa-book-medical mr-2" style={{ color: '#28a745' }}></i> Tổng quan CME
                                </h3>
                            </Card.Header>
                            <Card.Body className="pt-0 pb-3">
                                {cmeSummary.length === 0 ? (
                                    <div className="text-center text-muted py-3">
                                        <i className="fas fa-folder-open text-muted mb-2 d-block" style={{ fontSize: '1.5rem' }}></i>
                                        <p style={{ fontSize: '0.85rem', marginBottom: 0 }}>Chưa có dữ liệu CME</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="mb-4">
                                            <div className="d-flex justify-content-between align-items-end mb-1">
                                                <span className="text-muted font-weight-bold" style={{ fontSize: '0.85rem' }}>Năm {currentYear}</span>
                                                <span className="font-weight-bold text-success" style={{ fontSize: '0.9rem' }}>{totalHoursYear} / {requiredHoursYear} giờ</span>
                                            </div>
                                            <ProgressBar style={{ height: '8px', borderRadius: '4px' }}>
                                                <ProgressBar variant="success" now={progressPercentYear} key={1} />
                                                <ProgressBar variant="warning" now={(totalPendingHoursYear / requiredHoursYear) * 100} key={2} />
                                            </ProgressBar>
                                            <div className="d-flex justify-content-between mt-1">
                                                <span className="text-muted" style={{ fontSize: '0.75rem' }}>Đã duyệt: {totalHoursYear}h</span>
                                                {totalPendingHoursYear > 0 && <span className="text-warning" style={{ fontSize: '0.75rem' }}>Chờ duyệt: {totalPendingHoursYear}h</span>}
                                            </div>
                                        </div>

                                        <div>
                                            <div className="d-flex justify-content-between align-items-end mb-1">
                                                <span className="text-muted font-weight-bold" style={{ fontSize: '0.85rem' }}>Chu kỳ 5 năm</span>
                                                <span className="font-weight-bold text-primary" style={{ fontSize: '0.9rem' }}>{totalHoursCycle} / {requiredHoursCycle} giờ</span>
                                            </div>
                                            <ProgressBar variant="primary" now={progressPercentCycle} style={{ height: '8px', borderRadius: '4px' }} className="mb-1" />
                                            {/* <div className="text-right">
                                                <span className="text-muted" style={{ fontSize: '0.75rem' }}>{Math.round(progressPercentCycle)}% hoàn thành</span>
                                            </div> */}
                                        </div>
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                    </div>

                    {/* Right Column: Hiển thị Giấy phép hành nghề & Chứng chỉ chuyên môn */}
                    <div className="col-md-8 col-lg-9">
                        <Card style={{ borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', height: '100%', minHeight: '600px' }}>
                            <Card.Header className="bg-white border-0 pt-4 pb-2">
                                <h3 className="card-title font-weight-bold" style={{ fontSize: '1.1rem', color: '#1a202c' }}>
                                    <i className="fas fa-certificate mr-2" style={{ color: '#007bff' }}></i> Thông tin Hồ sơ Hành nghề
                                </h3>
                            </Card.Header>
                            <Card.Body className={listGPHN.length === 0 ? "d-flex align-items-center justify-content-center" : "p-4"}>
                                {listGPHN.length === 0 ? (
                                    <div className="text-center text-muted" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#ced4da" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="mb-3">
                                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                            <line x1="9" y1="3" x2="9" y2="21"></line>
                                            <path d="M13 8h4"></path>
                                            <path d="M13 12h4"></path>
                                            <path d="M13 16h4"></path>
                                        </svg>
                                        <p style={{ color: '#adb5bd', fontSize: '1rem' }}>Chưa có dữ liệu</p>
                                    </div>
                                ) : (
                                    <div className="w-100">
                                        {duyetHoSoStatus && duyetHoSoStatus.xacNhanDuyet && (
                                            <div className={`alert ${duyetHoSoStatus.xacNhanDuyet === 'Phù hợp' ? 'alert-success' : (duyetHoSoStatus.xacNhanDuyet === 'Không phù hợp' ? 'alert-danger' : 'alert-info')} mb-4 d-flex align-items-center shadow-sm`} style={{ borderRadius: '8px' }}>
                                                <i className={`fas ${duyetHoSoStatus.xacNhanDuyet === 'Phù hợp' ? 'fa-check-circle' : 'fa-info-circle'} mr-3`} style={{ fontSize: '1.5rem' }}></i>
                                                <div>
                                                    <h6 className="mb-1 font-weight-bold">Xác nhận phạm vi hành nghề: {duyetHoSoStatus.xacNhanDuyet}</h6>
                                                    {duyetHoSoStatus.nguoiDuyet && (
                                                        <span style={{ fontSize: '0.85rem' }}>
                                                            Người duyệt: <strong>{duyetHoSoStatus.nguoiDuyet}</strong> - Ngày: {formatDate(duyetHoSoStatus.ngayDuyet)}
                                                            {duyetHoSoStatus.xacNhanDuyet === 'Không phù hợp' && duyetHoSoStatus.lyDo && (
                                                                <> - Lý do: <strong>{duyetHoSoStatus.lyDo}</strong></>
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <h5 className="font-weight-bold mb-3 border-bottom pb-2" style={{ color: '#0056b3' }}>
                                            <i className="fas fa-file-medical-alt mr-2"></i>1. Giấy phép hành nghề
                                        </h5>
                                        {listGPHN.map((gphn, idx) => (
                                            <Card key={idx} className="mb-4 shadow-sm border-0" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <span className="text-muted d-block" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>Số giấy phép</span>
                                                            <strong className="text-dark">{gphn.soGiayPhep || '---'}</strong>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <span className="text-muted d-block" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>Loại giấy phép</span>
                                                            <strong className="text-dark">{getLoaiGiayPhep(gphn.loaiGiayPhep)}</strong>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <span className="text-muted d-block" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>Phạm vi hành nghề</span>
                                                            <strong className="text-dark">{gphn.phamViHanhNgheNames?.join(', ') || '---'}</strong>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <span className="text-muted d-block" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>Nơi cấp</span>
                                                            <strong className="text-dark">{getNoiCap(gphn.noiCap)}</strong>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <span className="text-muted d-block" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>Thời hạn</span>
                                                            <strong className="text-dark">
                                                                {formatDate(gphn.ngayCap)} {gphn.ngayHetHan ? ` - ${formatDate(gphn.ngayHetHan)}` : ''}
                                                            </strong>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <span className="text-muted d-block" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>Trạng thái</span>
                                                            <span className={`badge ${gphn.trangThai === 'Đã duyệt' ? 'badge-success' : (gphn.trangThai === 'Từ chối' ? 'badge-danger' : 'badge-warning')} px-2 py-1`} style={{ fontSize: '0.85rem' }}>
                                                                {gphn.trangThai || 'Chờ duyệt'}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-12 mt-2">
                                                            <span className="text-muted d-block mb-1" style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>File minh chứng</span>
                                                            {gphn.fileMinhChungPath ? (
                                                                <a href={resolveFileUrl(gphn.fileMinhChungPath)} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary shadow-sm" style={{ borderRadius: '20px', padding: '4px 15px' }}>
                                                                    <i className="fas fa-eye mr-2"></i>Xem minh chứng
                                                                </a>
                                                            ) : <span className="text-danger" style={{ fontSize: '0.85rem' }}><i className="fas fa-exclamation-circle mr-1"></i>Chưa đính kèm file</span>}
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        ))}

                                        <h5 className="font-weight-bold mb-3 border-bottom pb-2 mt-5" style={{ color: '#0056b3' }}>
                                            <i className="fas fa-award mr-2"></i>2. Chứng chỉ chuyên môn
                                        </h5>
                                        {listCCCM.length > 0 ? (
                                            <div className="row">
                                                {listCCCM.map((cccm, idx) => (
                                                    <div className="col-md-6 mb-3" key={idx}>
                                                        <Card className="shadow-sm border-0 h-100" style={{ borderLeft: '4px solid #17a2b8 !important' }}>
                                                            <Card.Body className="d-flex flex-column">
                                                                <h6 className="font-weight-bold text-dark mb-2" style={{ lineHeight: '1.4' }}>{cccm.tenChungChi || 'Tên chứng chỉ trống'}</h6>
                                                                <p className="text-primary mb-3" style={{ fontSize: '0.85rem', fontWeight: '500' }}>
                                                                    {cccm.loaiChungChi || 'Chưa cập nhật loại chứng chỉ'}
                                                                </p>
                                                                <div className="mt-auto">
                                                                    <p className="mb-2 text-muted" style={{ fontSize: '0.85rem' }}>
                                                                        <i className="fas fa-calendar-alt mr-2" style={{ width: '16px', textAlign: 'center' }}></i> 
                                                                        Ngày cấp: <strong className="text-dark">{formatDate(cccm.ngayCap)}</strong>
                                                                    </p>
                                                                    <p className="mb-3 text-muted" style={{ fontSize: '0.85rem' }}>
                                                                        <i className="fas fa-info-circle mr-2 text-info" style={{ width: '16px', textAlign: 'center' }}></i> 
                                                                        Trạng thái: <span className={`badge ${cccm.trangThai === 'Đã duyệt' ? 'badge-success' : (cccm.trangThai === 'Từ chối' ? 'badge-danger' : 'badge-warning')}`}>{cccm.trangThai || 'Chờ duyệt'}</span>
                                                                    </p>
                                                                    {cccm.fileMinhChungPath ? (
                                                                        <a href={resolveFileUrl(cccm.fileMinhChungPath)} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-info btn-block shadow-sm" style={{ borderRadius: '6px' }}>
                                                                            <i className="fas fa-file-download mr-2"></i>Xem chứng chỉ
                                                                        </a>
                                                                    ) : (
                                                                        <div className="text-center p-2 bg-light rounded text-danger" style={{ fontSize: '0.85rem' }}>
                                                                            <i className="fas fa-times-circle mr-1"></i> Không có file
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="alert alert-light text-center border mt-2">
                                                <i className="fas fa-box-open text-muted mb-2 d-block" style={{ fontSize: '2rem' }}></i>
                                                <span className="text-muted font-italic">Chưa có chứng chỉ chuyên môn nào.</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                </div>
        </div>
    );
};

export default Dashboard;
